import React, { useState } from 'react';
import './Transcript.scss';
import TeamMemberCard from '../TeamMemberCard/TeamMemberCard';
// import PersonalFeedback from '../PersonalFeedback/PersonalFeedback';
// import PeerFeedback from '../PeerFeedback/PeerFeedback';


const Transcript = (props) => {

    /* we will need at least two styles of entries.
            -The first will be a remake of the PersonalFeedback subcomponent
            -The second will be entirely generated by the info in the options object we're adding to the empty array
    
            Might want to look into assigning a type to each entry in the array to determin whether it is a PersonalFeedback entry or a selected option entry??

        Things that should get passed in:
            -transcript - the array of choices the user has made
            -transcriptVisibility state

    */
    console.log('Transcript props: ', props)

    const [slides] = useState(() => {
        let allSlides = {}
        for (let speaker of props.speakers) {
            let slides = props.scripts[speaker].presentationSlides
            for (let slide in slides) {
                allSlides[slide] = slides[slide]
            }
        }
        console.log('allSlides: ', allSlides)
        return allSlides;
    })

    return <div className='transcript'>

            <button className='close-modal' onClick={() => props.setTranscriptVisibility(false)}>X</button>

            <div className='pastConversation'>
                {/* below is the template for an option entry */}
                {props.transcript.map((entry, index) => {
                    const slide = slides[entry.slideId];
                    return <div key={`entry-${index}`}>
                        <div className='pastOption'>
                            <div className='option-container flex-start'>
                                {slide.person && <TeamMemberCard teamMember={props.people[slide.person]} />}
                                <p className='option-text' 
                                    dangerouslySetInnerHTML={{__html: slide.question ? slide.question : slide.prompt}}>
                                </p>
                            </div>
                        </div> 
                        <div className='pastOption'>
                            <div className='option-container flex-end'>
                                <p className='option-text'>{entry.option.option}</p>
                                <TeamMemberCard teamMember={props.teamMember}/>
                            </div>   
                        </div>
                    </div>
                })}
            </div>
        </div>

};

export default Transcript;